/**
 * @generated SignedSource<<eb5026bce9cb1e579e29fea9173a2b63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type LanguageIndicator_language$data = {
  readonly locale: Locale;
  readonly " $fragmentType": "LanguageIndicator_language";
};
export type LanguageIndicator_language$key = {
  readonly " $data"?: LanguageIndicator_language$data;
  readonly " $fragmentSpreads": FragmentRefs<"LanguageIndicator_language">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LanguageIndicator_language",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locale",
      "storageKey": null
    }
  ],
  "type": "Language",
  "abstractKey": null
};

(node as any).hash = "5a7588f790ff1eb54af7793203dd3920";

export default node;
